import type {
  CorporateEventStatus,
  CorporateEventType,
  SemanticDateRole,
  VerificationStatus,
} from "./types";

export const verificationLabels: Record<VerificationStatus, string> = {
  verified: "Zweryfikowane",
  supported: "Wsparte źródłem",
  needs_review: "Wymaga weryfikacji",
  rejected: "Odrzucone",
};

export const eventStatusLabels: Record<CorporateEventStatus, string> = {
  scheduled: "Zaplanowane",
  confirmed: "Potwierdzone",
  published: "Opublikowane",
  changed: "Termin zmieniony",
  cancelled: "Odwołane",
};

export const eventTypeLabels: Record<CorporateEventType, string> = {
  periodic_report: "Raport okresowy",
  preliminary_results: "Wyniki wstępne",
  report_schedule_change: "Zmiana harmonogramu raportów",
  guidance_update: "Aktualizacja prognoz zarządu",
  results_presentation: "Prezentacja wynikowa",
  dividend: "Dywidenda",
  general_meeting: "Walne zgromadzenie",
  strategy_update: "Aktualizacja strategii",
  insider_transaction: "Transakcja insidera",
  short_position: "Pozycja krótka",
  acquisition: "Przejęcie",
  disposal: "Sprzedaż aktywów",
  share_issue: "Emisja akcji",
  buyback: "Skup akcji",
  significant_contract: "Istotna umowa",
  other: "Inne zdarzenie",
};

export const dateRoleLabels: Record<SemanticDateRole, string> = {
  publication_date: "Data publikacji",
  reporting_period: "Okres raportowy",
  legal_reference_date: "Data aktu prawnego",
  document_date: "Data dokumentu",
  meeting_date: "Data spotkania",
  historical_date: "Data historyczna",
  unknown: "Nierozpoznana rola daty",
};
